import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Check, RefreshCw, Globe, ArrowRight } from "lucide-react";
import bsmlogo from "../../assets/bsm_mobile_logo.png"
import "./SubmitPage.css"
import { setApplicationId, setSessionId } from "../../redux/actions";
import { useDispatch } from "react-redux";
import { preserveAllUrlParams, restoreDynamicParamsFromStorage } from "../../utils/urlParams";

const SubmitPage = () => {
  const navigate=useNavigate()
  const dispatch=useDispatch()
  const location = useLocation();

  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("language");
    return saved === "Spanish" ? "Spanish" : "English";
  });

  useEffect(() => {
    const handleStorage = (e) => {
      if (e.key === "language") {
        setLang(e.newValue === "Spanish" ? "Spanish" : "English");
      }
    };

    const handleLangChanged = (e) => {
      const next = e?.detail;
      setLang(next === "Spanish" ? "Spanish" : "English");
    };

    window.addEventListener("storage", handleStorage);
    window.addEventListener("langChanged", handleLangChanged);
    return () => {
      window.removeEventListener("storage", handleStorage);
      window.removeEventListener("langChanged", handleLangChanged);
    };
  }, []);

  const t = useMemo(() => {
    const translations = {
      English: {
        title: "Form Submitted Successfully!",
        descriptionPrefix: "Thank you for your submission! One of our ",
        mortgageAdvisors: "Mortgage Advisors",
        descriptionSuffix: " will reach out to you shortly",
        anotherApplication: "Another Application",
        homeWebsite: "Home Website",
      },
      Spanish: {
        title: "¡Formulario enviado con éxito!",
        descriptionPrefix: "¡Gracias por su envío! Uno de nuestros ",
        mortgageAdvisors: "Asesores Hipotecarios",
        descriptionSuffix: " se comunicará con usted en breve",
        anotherApplication: "Otra solicitud",
        homeWebsite: "Sitio web",
      },
    };

    return translations[lang] || translations.English;
  }, [lang]);
  const handleHomeWebsite = () => {
    // Add your navigation logic for another application
    window.location.href="https://bondstreetloans.com/"
    // In your actual app, use: navigate("/application");
  };

   const handleHomeClick=()=>{
    localStorage.removeItem("session_id")
    localStorage.removeItem("application_id")
    localStorage.removeItem("formType")
    localStorage.removeItem("formData")

    dispatch(setSessionId(null));
    dispatch(setApplicationId(null))
    
    // Preserve all URL parameters (both registered and dynamic)
    const searchParams = preserveAllUrlParams(location.search);
    
    // Restore dynamic parameters from localStorage if not in URL
    restoreDynamicParamsFromStorage(searchParams);
    
    // Ensure required parameters have defaults if missing
    if (!searchParams.has("lar")) {
      const larFromStorage = localStorage.getItem("lar") || "admin";
      searchParams.set("lar", larFromStorage);
    }
    if (!searchParams.has("utm_source")) {
      const sourceFromStorage = localStorage.getItem("utm_source") || "direct";
      searchParams.set("utm_source", sourceFromStorage);
    }
    
    // Handle optional parameters from localStorage if not in URL
    if (!searchParams.has("utm_term")) {
      const kwFromStorage = localStorage.getItem("utm_term");
      if (kwFromStorage) {
        searchParams.set("utm_term", kwFromStorage);
      }
    }
    
    if (!searchParams.has("utm_campaign")) {
      const campaignFromStorage = localStorage.getItem("utm_campaign");
      if (campaignFromStorage) {
        searchParams.set("utm_campaign", campaignFromStorage);
      }
    }
    
    if (!searchParams.has("utm_type")) {
      const utmTypeFromStorage = localStorage.getItem("utm_type");
      if (utmTypeFromStorage) {
        searchParams.set("utm_type", utmTypeFromStorage);
      }
    }
    
    navigate(`${process.env.REACT_APP_BASE_URL}?${searchParams.toString()}`)
  }

  return (
    <div className="success-page-container">
      <div className="success-card">
        {/* Header Section */}
        <div className="success-header">
          <div className="success-header-overlay"></div>
          <div className="success-content">
            {/* Logo Image */}
           
            
            {/* Success Icon */}
            <div className="success-icon-wrapper">
              <div className="success-icon-inner">
                <Check className="success-check-icon" strokeWidth={3} />
              </div>
            </div>
            
            {/* Success Message */}
            <h1 className="success-title">
              {t.title}
            </h1>
            <div className="success-divider"></div>
          </div>
        </div>

        {/* Content Section */}
        <div className="success-body">
           <div className="logo-container">
              <img 
                src={bsmlogo} 
                alt="Company Logo" 
                className="company-logo"
              />
            </div>
          <p className="success-description">
            {t.descriptionPrefix}<span className="highlight-text">{t.mortgageAdvisors}</span>{t.descriptionSuffix}
          </p>
          
          {/* Action Buttons */}
          <div className="action-buttons-container">
            <button onClick={handleHomeClick} className="primary-action-button">
              <RefreshCw className="button-icon" />
              {t.anotherApplication}
              <ArrowRight className="arrow-icon" />
            </button>
            
            <button onClick={handleHomeWebsite} className="primary-action-button secondary-button">
              <Globe className="button-icon" />
              {t.homeWebsite}
              <ArrowRight className="arrow-icon" />
            </button>
          </div>
        </div>
      </div>

      {/* Floating Elements */}
      <div className="floating-element floating-element-1"></div>
      <div className="floating-element floating-element-2"></div>

    </div>
  );
};

export default SubmitPage
